import React from 'react';
import { Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { IconWrapper } from 'components/Icon';

export const RateValue = ({ value, excluded, label, onClick }) => {
  const theme = useTheme();

  if (excluded) {
    return (
      <IconWrapper
        icon="xMark"
        role="img"
        aria-label="Excluded"
        height={18}
        display="flex"
        my={1.5}
        sx={{
          svg: {
            width: 18,
            height: 18,
            color: theme.palette.text.disabled,
            stroke: theme.palette.text.disabled,
          },
        }}
      />
    );
  }

  if (value && onClick) {
    return (
      <Link
        component="button"
        variant="body2"
        fontWeight={600}
        whiteSpace="nowrap"
        underline="hover"
        aria-label={`${label}: ${value}`}
        onClick={onClick}
        sx={{ px: 1, py: 1.5 }}
      >
        {value}
      </Link>
    );
  }

  return (
    <Typography
      variant="body2"
      fontWeight={600}
      color={value ? 'text.primary' : 'text.secondary'}
      whiteSpace="nowrap"
      px={1}
      py={1.5}
    >
      {value || '–'}
    </Typography>
  );
};
